import { BriefItem } from '../../../types';

export const formatBriefCardSubtitle = ({ createDate, userDisplayName }: BriefItem) =>
    `${userDisplayName} | ${new Date(createDate).toLocaleDateString()}`;
